import { ContentService } from '@blk/cwp-ng-framework';
import { BfaConstants } from '@ddt-web/domain';
import * as isNil from 'lodash/isNil';

import { Formatter } from './formatter.interface';
import { NumberFormatter } from './number-formatter';

export class NumberToPercentFormatter implements Formatter {
	constructor(private decimal: number = BfaConstants.DEFAULT_DECIMAL_PLACES) { }
	public format(value: any, contentSvc?: ContentService): string {
		const formatter = new NumberFormatter(NumberFormatter.PERCENT, this.decimal);
		if (isNil(value)) {
			return formatter.format(value);
		}
		return formatter.format(value * 100);
	}
}
